<app-video-js-player [course]="course" (vjsPendingStatusChange)="updatePendingStatusChange($event)"></app-video-js-player>